<script lang="ts">
    export let text: string;
</script>

<section class="mb-4 grid columns-1 justify-items-center pt-5 leading-5 md:text-xl md:leading-6">
    <div class="whitespace-normal md:w-2/3 lg:w-1/2">
        {@html text}
    </div>
</section>

<style>
    div > :global(p:nth-child(even)) {
        @apply ml-[19%];
    }
</style>
